export enum ServiceWorkOrderTypes {
  Undefined = 0,
  OriginalCall = 1,
  PossibleRecall = 3,
  TrueRecall = 5,
  SecondOpinion = 7,
  HWSFollowup = 51,
  SecondOpinionWon = 9,
  Continuation = 13,
  Transfer = 15
}



// WEBPACK FOOTER //
// ./src/_constants/ServiceWorkOrderTypes.ts